import { createContext } from "react";
import { Config } from "~/drizzle/schema";
type WhiteLabelConfigContextProps = {
  config: Config | undefined;
  setConfig: (config: Config) => void;
};
export const WhiteLabelConfigContext = createContext<WhiteLabelConfigContextProps | null>(null);